import React ,{useState,useEffect}from 'react'
import api from '../api/api.list'
import baseUrl from '../config.json'
import socketIOClient from 'socket.io-client'
const ENDPOINT = baseUrl.apiEndPoint

function SideBar() {
    const [notification, setNotification] = useState([])

    useEffect(()=>{
        getNotification()
        const socket = socketIOClient(ENDPOINT)
    socket.on('FromAPI', data => {
      if (data != '') {
        getNotification()
      }
    })
    },[])

    const getNotification = () =>{
        api.getnotification().then(res=>{
            console.log("-->",res.data)
            setNotification(res.data)
        })
    }
    return (
        <nav class="navbar navbar-default">
            <div class="container-fluid">
                <div class="collapse navbar-collapse">
                    <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown" style={{'background-color':'white'}}>
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                <p>Notifications</p>
                                <b class="caret"></b>
                            </a>
                            <ul class="dropdown-menu" style={{'max-height':'300px','overflow':'auto'}}>
                            <li><a><b>Todays Updates</b></a></li>
                                        <hr style={{'margin-top':'0px','margin-bottom':'0px'}}/>
                            {
                                notification.map((item)=>{

                                    let status="Pending"
                                    if(item.approvalstatus==1)
                                    {
                                        status="Denied"
                                    }else if(item.approvalstatus==2)
                                    {
                                        status="Approved"
                                    }else if(item.approvalstatus==3)
                                    {
                                        status="Query"
                                    }else if(item.approvalstatus==4)
                                    {
                                        status="Partially Approved"
                                    }else if(item.approvalstatus==5)
                                    {
                                        status="Cancelled"
                                    }

                                    return(
                                        <>
                                       
                                    <li><a>{item.mrnumber+' status updated to '+status}</a></li>
                                    </>
                                    )
                                })
                            }
                                
                            </ul>
                        </li>
                        <li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                <p>{localStorage.username.toUpperCase()}</p>
                                <b class="caret"></b>
                            </a>
                            <ul class="dropdown-menu">
                                
                                {localStorage.role != 'ROLE_USER' &&
                                <>
                                    <li><a href="/register">Users</a></li>
                                    <li><a href="/passwordreset">Reset Password</a></li>
                                    <li><a href="/createrole">Create Role</a></li>
                                    </>
                                }
                                 
                                <li><a onClick={() => {
                                    localStorage.removeItem('userid')
                                    window.location = '/login'
                                }}>Log Out</a></li>
                            </ul>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </nav>
    )
}
export default SideBar